import { Box } from '@material-ui/core';
import { useLoanStore } from '@roc/feature-loans';
import { LoanSubType, LoanType } from '@roc/feature-utils';
import { observer } from 'mobx-react';
import { LoanSummaryBridge } from '../components/bridge/loanSummaryBridge';
import { LoanSummaryBridgeV2 } from '../components/bridge/loanSummaryBridgeV2';
import { LoanSummaryMultifamilyBridge } from '../components/bridge/loanSummaryMultifamilyBridge';
import { LoanSummaryStabilizedBridge } from '../components/bridge/loanSummaryStabilizedBridgeV2'
import { LoanSummaryTerm } from '../components/term/loanSummaryTermV2';
import { useEffect } from 'react';

export const LoanSummaryTab = observer(() => {
  const { loanStore } = useLoanStore();
  const { loanDetails } = loanStore;

  useEffect(() => {
    loanStore.fetchPropertyApprailFilterMap();
  }, []);

  const loanType: LoanType = loanDetails?.loanType;
  const loanSubType: LoanSubType = loanDetails?.loanSubType;
  if (loanType === LoanType.RESIDENTIAL_BRIDGE) {
    if (loanSubType === LoanSubType.STABILIZED_BRIDGE) {
      return (
        <>
          <LoanSummaryStabilizedBridge />
        </>
      );
    } else if (loanSubType === LoanSubType.MULTIFAMILY_BRIDGE_5PLUS) {
      return (
        <>
          <LoanSummaryMultifamilyBridge />
        </>
      );
    } else if (loanSubType === LoanSubType.GROUND_UP) {
      return (
        <>
          <LoanSummaryBridgeV2 groundUp />
        </>
      );
    } else {
      return (
        <>
          <LoanSummaryBridgeV2 />
        </>
      );
    }
  }

  if (loanType === LoanType.RESIDENTIAL_TERM) {
    return (
      <>
        <LoanSummaryTerm />
      </>
    );
  }

  return null;
});
